// extracted by mini-css-extract-plugin
export default {"melodyVideo":"kP-z","isFullWidth":"lP-z","landingPageVideo":"mP-z","play":"nP-z","iframeVideo":"oP-z","playHidden":"pP-z","fullwidth":"qP-z"};